<template>
<div class="chapter">
<div class="inner_page">
<div class="img_container"><a id="page_i"></a><a id="page_ii"></a>
<img alt="Images" src="images/f0002-1.jpg"/>
<p class="cap">EDISON IN HIS CHEMICAL LABORATORY</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Fr_img.vue?84490d28